'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  pointer-events: none;\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  z-index: 31;\n  background-color: rgba(0,0,0,0);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n  transition: background-color 2s;\n  aside {\n    transform: translateY(100vh);\n    transition: transform 2s;\n  }\n  &.active {\n    background-color: rgba(0,0,0,0.75);\n    aside {\n      transform: translateY(0vh);\n    }\n  }\n'], ['\n  pointer-events: none;\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  z-index: 31;\n  background-color: rgba(0,0,0,0);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n  transition: background-color 2s;\n  aside {\n    transform: translateY(100vh);\n    transition: transform 2s;\n  }\n  &.active {\n    background-color: rgba(0,0,0,0.75);\n    aside {\n      transform: translateY(0vh);\n    }\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  pointer-events: auto;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  width: 95%;\n  height: 95%;\n'], ['\n  pointer-events: auto;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  width: 95%;\n  height: 95%;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  color: white;\n  font-size: 2rem;\n  .fa {\n    margin-left: 0.5em;\n  }\n  &:hover {\n    cursor: pointer;\n  }\n'], ['\n  color: white;\n  font-size: 2rem;\n  .fa {\n    margin-left: 0.5em;\n  }\n  &:hover {\n    cursor: pointer;\n  }\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  width: 100vw;\n  height: calc(100vh - 4rem);\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  background-image: ', ';\n  background-position: center;\n  background-size: cover;\n  background-repeat: none;\n  padding: 2rem;\n'], ['\n  width: 100vw;\n  height: calc(100vh - 4rem);\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  background-image: ', ';\n  background-position: center;\n  background-size: cover;\n  background-repeat: none;\n  padding: 2rem;\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n  width: 100%;\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0.1rem;\n  color: #000;\n  font-size: 1.5rem;\n  text-align: center;\n  color: #BF0A30;\n'], ['\n  width: 100%;\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0.1rem;\n  color: #000;\n  font-size: 1.5rem;\n  text-align: center;\n  color: #BF0A30;\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n  width: 100%;\n  box-sizing: border-box;\n  padding: 0.5rem;\n  display: flex;\n  flex-direction: column;\n  flex-wrap: wrap;\n  overflow: auto;\n  a {\n    color: #333;\n    text-decoration: none;\n    &:hover {\n      text-decoration: underline;\n    }\n    margin-right: 2rem;\n  }\n'], ['\n  width: 100%;\n  box-sizing: border-box;\n  padding: 0.5rem;\n  display: flex;\n  flex-direction: column;\n  flex-wrap: wrap;\n  overflow: auto;\n  a {\n    color: #333;\n    text-decoration: none;\n    &:hover {\n      text-decoration: underline;\n    }\n    margin-right: 2rem;\n  }\n']),
    _templateObject7 = _taggedTemplateLiteral(['\n  width: 100%;\n  text-align: center;\n  font-size: 1.1rem;\n  color: #002868;\n  a, a:hover, a:active, a:visited {\n    color: #BF0A30;\n  }\n  a:hover {\n    font-weight: bold;\n  }\n'], ['\n  width: 100%;\n  text-align: center;\n  font-size: 1.1rem;\n  color: #002868;\n  a, a:hover, a:active, a:visited {\n    color: #BF0A30;\n  }\n  a:hover {\n    font-weight: bold;\n  }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouterDom = require('react-router-dom');

var _reactFontawesome = require('react-fontawesome');

var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); } // TODO: Custom link colors

var Wrapper = _styledComponents2.default.div(_templateObject);

var Dialog = _styledComponents2.default.aside(_templateObject2);

var CloseButton = _styledComponents2.default.div(_templateObject3);

var Background = _styledComponents2.default.div(_templateObject4, function (props) {
  return 'url(' + props.image + ')';
});

var Title = _styledComponents2.default.h1(_templateObject5);

var Listing = _styledComponents2.default.div(_templateObject6);

var ExhibitorCall = _styledComponents2.default.div(_templateObject7);

/** @class ExhibitorListing
  * A component for listing all booths in the show
  * as alphabatized navigation links.
  * @prop {string} name - the name of the show
  * @prop {Object} booths - a map of all booths in
  * the show.
  * @prop {URLString} background (optional) - a background image to display behind the booth listing
  */

var ExhibitorListing = function (_Component) {
  _inherits(ExhibitorListing, _Component);

  /** @constructor
    * Creates a new instance of BoothListing
    */
  function ExhibitorListing(props) {
    _classCallCheck(this, ExhibitorListing);

    // Alphabatize the booths
    var _this = _possibleConstructorReturn(this, (ExhibitorListing.__proto__ || Object.getPrototypeOf(ExhibitorListing)).call(this, props));

    var booths = [];
    for (var key in props.booths) {
      var booth = {
        id: key,
        name: _this.props.booths[key].name,
        path: '/booth/' + key
      };
      booths.push(booth);
    }
    _this.state = {
      visible: false,
      booths: booths.sort(function (a, b) {
        return a.name.localeCompare(b.name);
      })
    };
    return _this;
  }
  /** @method componentWillMount
    * Adds the showBoothListing function
    * to the global vexpo object.
    */


  _createClass(ExhibitorListing, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _this2 = this;

      if (!window.vexpo) window.vexpo = {};
      window.vexpo.showBoothListing = function () {
        return _this2.setState({
          visible: true
        });
      };
    }
    /** @method render
      * Renders the booth listing instance.
      */

  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var booths = this.state.booths.map(function (booth) {
        return _react2.default.createElement(
          _reactRouterDom.Link,
          { key: booth.id, to: booth.path, onClick: function onClick() {
              return _this3.setState({ visible: false });
            } },
          booth.name
        );
      });
      return _react2.default.createElement(
        Wrapper,
        { className: this.state.visible ? 'active' : '' },
        _react2.default.createElement(
          Dialog,
          null,
          _react2.default.createElement(
            CloseButton,
            { onClick: function onClick() {
                return _this3.setState({ visible: false });
              } },
            'CLOSE',
            _react2.default.createElement(_reactFontawesome2.default, { name: 'times' })
          ),
          _react2.default.createElement(
            Background,
            { image: this.props.background },
            _react2.default.createElement(
              Title,
              null,
              this.props.name
            ),
            _react2.default.createElement(
              Title,
              null,
              'Exhibitor Listing'
            ),
            _react2.default.createElement(
              Listing,
              null,
              booths
            ),
            _react2.default.createElement(
              ExhibitorCall,
              null,
              'Interested in exhibiting in future shows? Please contact us at',
              _react2.default.createElement(
                'a',
                { href: 'mailto:info@vexposhows.com' },
                ' info@vexposhows.com'
              )
            )
          )
        )
      );
    }
  }]);

  return ExhibitorListing;
}(_react.Component);

exports.default = ExhibitorListing;


ExhibitorListing.propTypes = {
  name: _propTypes2.default.string.isRequired,
  booths: _propTypes2.default.object.isRequired,
  background: _propTypes2.default.string
};


//////////////////
// WEBPACK FOOTER
// ../vexpo-components/build/navigation/exhibitor-listing.js
// module id = 1073
// module chunks = 0